import { authentificationRepository } from '../repositories/authentication-repository';

async function signInBySubscription(subscriptionId) {
    if (!subscriptionId) {
        throw Error('Invalid subscriptionId parameter');
    }

    return authentificationRepository.signInBySubscription(subscriptionId);
}

export {
    signInBySubscription
};
